import React from 'react';
import Icon from '../../../components/AppIcon';

const ThreatIndicator = ({ threat }) => {
  const getSeverityConfig = (severity) => {
    const configs = {
      'Critical': { 
        color: 'bg-error text-error-foreground', 
        icon: 'AlertTriangle',
        pulse: 'pulse-urgent'
      },
      'High': { 
        color: 'bg-warning text-warning-foreground', 
        icon: 'AlertCircle',
        pulse: 'pulse-conservation'
      },
      'Medium': { 
        color: 'bg-accent text-accent-foreground', 
        icon: 'Info',
        pulse: ''
      },
      'Low': { 
        color: 'bg-info text-info-foreground', 
        icon: 'CheckCircle',
        pulse: ''
      }
    };
    return configs?.[severity] || configs?.Medium;
  };

  const config = getSeverityConfig(threat?.severity);

  return (
    <div className={`bg-[var(--color-card)] rounded-lg p-4 shadow-conservation border-l-4 ${config?.color?.split(' ')?.[0]?.replace('bg-', 'border-')} border border-[var(--color-border)]`}>
      <div className="flex items-start gap-3">
        <div className={`${config?.color} rounded-full p-2 ${config?.pulse}`}>
          <Icon name={config?.icon} size={20} />
        </div>
        
        <div className="flex-1">
          <div className="flex items-center justify-between mb-2">
            <h4 className="text-base font-semibold text-[var(--color-foreground)]">{threat?.type}</h4>
            <span className={`px-2 py-1 rounded text-xs font-medium ${config?.color}`}>
              {threat?.severity}
            </span>
          </div>
          
          <p className="text-sm text-[var(--color-muted-foreground)] mb-3">{threat?.description}</p>
          
          <div className="grid grid-cols-2 gap-3 text-xs">
            <div>
              <span className="text-[var(--color-muted-foreground)]">Affected Species:</span>
              <span className="text-[var(--color-foreground)] ml-1 font-medium">{threat?.affectedSpecies}</span>
            </div>
            <div>
              <span className="text-[var(--color-muted-foreground)]">Detected:</span>
              <span className="text-[var(--color-foreground)] ml-1 font-medium">{threat?.detectedDate}</span>
            </div>
          </div>

          {threat?.actionPlan && (
            <div className="mt-3 pt-3 border-t border-border">
              <p className="text-xs text-[var(--color-muted-foreground)] mb-1">Action Plan:</p>
              <p className="text-sm text-[var(--color-foreground)]">{threat?.actionPlan}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ThreatIndicator;